import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminTicketDetailComponent from '../../../components/Admin/tickets/AdminTicketDetailComponent';

const AdminTicketEditPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate('/admin/ticket');
    }

    return <AdminTicketDetailComponent ticketId={ params.ticketId } shouldRedirect={ () => redirectBack()} />;
}

export default AdminTicketEditPage;